const ProfileEnum = Object.freeze({
    STUDENT: 'Estudante',
    TEACHER: 'Docente',
    SUPERVISOR: 'Supervisor',
    ADMIN: 'Admin'
});

export default ProfileEnum;
